import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public isMobile: boolean;
  isBackToResultList: boolean;
  title = 'Catalogue des Tests';
  isSearcheable = true;
  queryField: FormControl = new FormControl();

  constructor(public router: Router, private activeRoute: ActivatedRoute ) {
  }

  ngOnInit() {

    this.isMobile = (window.innerWidth <= 700);
    window.onresize = () => this.isMobile = (window.innerWidth <= 700);

    this.router.events.subscribe(this.onUrlChange.bind(this));
    this.computeTitle(this.router.url);


  }

  onUrlChange(ev) {
    if (ev instanceof NavigationEnd) {
      const url = ev.url;
      this.computeTitle(url);

    }
  }


  navigate(path: string) {
    this.router.navigate(['/' + path]);
  }


  private computeTitle(url: any) {
    if (url.indexOf('resources') !== -1) {
      if (this.isMobile) {
        this.title = 'Resources';
      } else {
        this.title = 'Resources';
      }
      this.isSearcheable = true;
      this.isBackToResultList = false;
    } else if (url.indexOf('my-subscriptions') !== -1) {
      this.title = 'My Subscriptions';
      this.isSearcheable = false;
      this.isBackToResultList = false;
    } else if (url.indexOf('faq') !== -1) {
      this.title = 'F.A.Q';
      this.isSearcheable = false;
      this.isBackToResultList = false;
    } else if (url.indexOf('plans') !== -1) {
      this.title = 'Plans';
      this.isSearcheable = false;
      this.isBackToResultList = false;
    } else {
      this.title = 'Dashboard';
      this.isSearcheable = false;
      this.isBackToResultList = false;
    }
  }


}
